<template>
    <div>
        <van-popover v-model="showPopover" trigger="click" :offset="[-20, 10]">
            <div class="popoverBox">
                <div class="popoverBox_title">
                    {{ $t('lang.选择网络') }}
                </div>
                <div v-for="item in NetConfig" @click="Change(item)" class="popoverBox_item">
                    <div class="img">
                        <img :src="item.logoURI" alt="">
                    </div>
                    <span :style="{ color: netWorkConfig.chainId == item.chainId ? 'rgb(60, 122, 134)' : '' }">{{
                        item.NetWorkName }}</span>
                </div>
            </div>
            <template #reference>
                <div class="addressBox">
                    <div class="account" style="display: flex; align-items: center">
                        <img style="width: 20px; margin-right: 5px; height: 20px" :src="netWorkConfig.logoURI" alt="" />
                        {{ netWorkConfig.NetWorkName }}
                    </div>
                </div>
            </template>
        </van-popover>

    </div>
</template>

<script>
import { mapState } from 'vuex';
import { NetConfig } from '@/config/constants/netWorkConfig.js';
import { watch } from 'less';
export default {
    data() {
        return {
            showPopover: false,
            NetConfig
        }
    },
    watch: {
        netWorkConfig(newd, old) {

            if (newd.chainId != old.chainId) {
                window.location.reload();
            }


        }
    },
    computed: {
        ...mapState(['netWorkConfig']),

    },
    components: {

    },
    mounted() {

    },
    methods: {
        Change(item) {
            this.$store.commit('SETNETWORKCINFIG', item);
            this.showPopover = false
        },
    },
}

</script>
<style scoped lang='less'>
.addressBox {
    margin-left: 12px;
    padding: 2px 5px;
    border-radius: 44px;

    border: 1px solid #000;
    // padding: 5px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #000;
    font-weight: 500;
}

.popoverBox {
    width: 150px;

    .popoverBox_title {
        padding: 5px 5px 5px 10px;
        font-size: 14px;
        font-weight: bold;
        border-bottom: 1px solid rgb(102, 180, 174);
        padding-bottom: 5px;
    }

    .popoverBox_item {
        padding: 6px;
        padding-left: 10px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: bold;

        .img {
            width: 27px;
            height: 27px;
            margin-right: 10px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>